<script setup>
import logo from '../../images/rentrisk-logo.png';
</script>

<template>
    <img :src="logo" />
</template>
